import { IconSvgProps } from '../types';

export const Sparkle = ({ size }: IconSvgProps) => (
	<svg
		id="icon-content-process"
		width={size}
		height={size}
		viewBox="0 0 28 28"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.3333 3.33333L18 5L21.3333 6.66667L23 10L24.6667 6.66667L28 5L24.6667 3.33333L23 0L21.3333 3.33333Z"
			fill="#BF63F3"
		/>
		<path d="M8 10L0 14L8 18L12 26L16 18L24 14L16 10L12 2L8 10Z" fill="#BF63F3" />
		<path
			d="M17 23L20.3333 21.3333L22 18L23.6667 21.3333L27 23L23.6667 24.6667L22 28L20.3333 24.6667L17 23Z"
			fill="#BF63F3"
		/>
	</svg>
);
